import { Component, OnInit } from '@angular/core';
import {DisplayedColumnInf} from '../../../interfaces/common/table/displayed-column-inf';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {
  TimeBasedRoutingApiService
} from '../../../services/api/settings/routing/time-based-routing/time-based-routing-api.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {AcDialogService} from 'ac-infra';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import {MatDialog} from '@angular/material/dialog';
import {LicenseFeaturesService} from '../../../services/common/license-features/license-features.service';
import {TimeBasedRoutingDialogComponent} from './time-based-routing-dialog/time-based-routing-dialog.component';
import _ from 'lodash';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'time-based-routing',
  templateUrl: './time-based-routing.component.html',
  styleUrls: ['./time-based-routing.component.scss']
})
export class TimeBasedRoutingComponent implements OnInit {

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'name', display: 'Name', selected: true,  width: 200},
    {name: 'type', display: 'Type', selected: true, width: 100}
  ];

  selection;
  isUnauthorized: boolean;
  isTBRDisabled: boolean;
  data: any;

  constructor(private userPrivilege: UserPrivilegeService,
              private timeBasedRoutingApiService: TimeBasedRoutingApiService,
              private licenseFeaturesService: LicenseFeaturesService,
              private loaderService: LoaderService,
              private acDialogService: AcDialogService,
              private snackBarService: SnackBarService,
              private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.loaderService.showMainContainer();
    this.isUnauthorized = !this.userPrivilege.isAuthorized();

    this.licenseFeaturesService.isFeatureSupported('tbr').subscribe(isFeatureSupported => {
      this.isTBRDisabled = !isFeatureSupported;
    });

    this.refresh();
  }

  addTimeCondition(): void {
    const dialogData = {
      tbr: {name: ''},
      tbrForSubmit: {name: ''},
      isEditMode: false
    };

    this.acDialogService.open(TimeBasedRoutingDialogComponent, {
      dialogData,
      title: 'Add Time condition',
      onSubmit: () => {
        return this.timeBasedRoutingApiService.addTimeCondition(dialogData.tbrForSubmit).toPromise().then(() => {
          this.refresh();
          this.snackBarService.display(`${dialogData.tbrForSubmit.name} successfully added`);
        });
      }
    });
  }

  updateTimeCondition(): void {
    const dialogData = {
      tbr: _.cloneDeep(this.selection),
      tbrForSubmit: {name: ''},
      isEditMode: true
    };

    this.acDialogService.open(TimeBasedRoutingDialogComponent, {
      dialogData,
      title: 'Edit Time condition',
      onSubmit: () => {
        return this.timeBasedRoutingApiService.editTimeCondition(dialogData.tbrForSubmit, this.selection.id).toPromise().then(() => {
          this.refresh();
          this.snackBarService.display(`${dialogData.tbrForSubmit.name} successfully updated`);
        });
      }
    });
  }

  deleteTimeConditions(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Are you sure you want to delete the time condition: "${this.selection.name}" ?`
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.timeBasedRoutingApiService.deleteTimeCondition(this.selection.id).subscribe(() => {
        dialogRef.close();
        this.refresh();
        this.snackBarService.display(`${this.selection.name} successfully deleted`);
      }, () => {
      });
    });
  }

  refresh(): void {
    this.timeBasedRoutingApiService.getTimeConditions().subscribe(data => {
      this.data = data;
      this.loaderService.hideMainContainer();
    });
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }
}
